import { ref, useAttrs, computed, watch, openBlock, createBlock, createSlots, withCtx, createVNode, mergeProps, renderList, renderSlot, normalizeProps, guardReactiveProps, createElementBlock, Fragment, createTextVNode, toDisplayString } from "vue";
import UikitInputNew from "./InputNew.vue.es.js";
import UikitDropdown from "../Dropdown.vue.es.js";
import { INPUT_AUTOCOMPLETE_PROPS } from "./input.es.js";
import UikitMenu from "../Menu/Menu.vue.es.js";
import _sfc_main$1 from "../Menu/MenuItem.vue.es.js";
/* empty css                        */
import _export_sfc from "../../uikit._virtual/_plugin-vue_export-helper.es.js";
const _sfc_main = {
  __name: "AutocompleteNew",
  props: {
    ...INPUT_AUTOCOMPLETE_PROPS,
    standalone: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update:modelValue", "onSelectOption", "onChange"],
  setup(__props, { emit: __emit }) {
    const innerDropDown = ref(null);
    const showOptions = ref(false);
    const emit = __emit;
    const props = __props;
    const attrs = useAttrs();
    const inputProps = computed(() => ({
      ...attrs,
      ...props,
      syncVModel: false,
      standalone: props.standalone
    }));
    const handleValueUpdate = (value) => {
      emit("update:modelValue", value);
    };
    const handleFocus = () => {
      showOptions.value = true;
    };
    const handleSelectOption = (option) => {
      emit("onSelectOption", option);
      emit("update:modelValue", option.value);
      showOptions.value = false;
    };
    watch(
      () => props.options,
      () => {
        innerDropDown.value.refreshPosition();
      }
    );
    return (_ctx, _cache) => {
      return openBlock(), createBlock(UikitDropdown, {
        ref_key: "innerDropDown",
        ref: innerDropDown,
        modelValue: showOptions.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => showOptions.value = $event),
        class: "uikit-auto-complete-new",
        autoHeight: "",
        trigger: "click"
      }, createSlots({
        default: withCtx(() => [
          createVNode(UikitInputNew, mergeProps(inputProps.value, {
            class: "uikit-input-price",
            "onUpdate:modelValue": handleValueUpdate,
            onOnFocus: handleFocus
          }), createSlots({ _: 2 }, [
            renderList(_ctx.$slots, (_, name) => {
              return {
                name,
                fn: withCtx((slotData) => [
                  renderSlot(_ctx.$slots, name, normalizeProps(guardReactiveProps(slotData)), void 0, true)
                ])
              };
            })
          ]), 1040)
        ]),
        _: 2
      }, [
        _ctx.options.length ? {
          name: "overlay",
          fn: withCtx(() => [
            createVNode(UikitMenu, null, {
              default: withCtx(() => [
                (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.options, (option, index) => {
                  return openBlock(), createBlock(_sfc_main$1, {
                    id: option.value + "-" + index,
                    key: index,
                    onClick: ($event) => handleSelectOption(option)
                  }, {
                    default: withCtx(() => [
                      renderSlot(_ctx.$slots, "option", mergeProps({ ref_for: true }, option), () => [
                        createTextVNode(toDisplayString(option.label), 1)
                      ], true)
                    ]),
                    _: 2
                  }, 1032, ["id", "onClick"]);
                }), 128))
              ]),
              _: 3
            })
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["modelValue"]);
    };
  }
};
const AutocompleteNew = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-eea0c509"]]);
export {
  AutocompleteNew as default
};
//# sourceMappingURL=AutocompleteNew.vue.es.js.map
